/****************************************************
 * Module Name:  proformaAccount.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Select from "react-select";
import { Box, Button, CircularProgress, TextField, Tooltip, Typography, Stack, FormGroup, Switch, FormControlLabel, MenuItem, Menu } from "@mui/material";
import Constants from "../../utility/constants";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { ThemeProvider, createTheme } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import SalesProxy from "../../utility/proxy/manager/reportSalesProxy";
import StoneDetailModal from "../common/stoneDetailModal";
import { LoadingButton } from "@mui/lab";
import CommonSnackbar from "../common/commonSnackBar";
import { BsFilePdf } from "react-icons/bs";
import NoPermission from "../common/noPermission";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import PDFModal from "../common/pdfModal";
import dayjs from "dayjs";
import CommonStoneSelection from "../common/commonStoneSelection";
import VideoLibraryTwoToneIcon from '@mui/icons-material/VideoLibraryTwoTone';
import StoneMediaModal from "../common/stoneMediaModal";
import PageTitle from "../common/pageTitle";
import Download from "@mui/icons-material/Download";
import { createExcelFile } from "../common/createExcelFile";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";
import * as XLSX from "sheetjs-style";
import { TbTableExport } from "react-icons/tb";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { styled, alpha } from "@mui/material/styles";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.tableLayouts = {
    Mylayout: {
        fillColor: function (rowIndex, node, columnIndex) {
            return rowIndex % 2 === 0 ? "#CCCCCC" : null;
        },
    },
};

const lStatusOption = [
    { value: -1, label: "-- ANY --" },
    { value: "NEW", label: "NEW" },
    { value: "INPROGRESS", label: "INPROGRESS" },
    { value: "CLOSED", label: "CLOSED" },
    { value: "DELETED", label: "DELETED" }
];

const StyledMenuButtons = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 100,
        color:
            theme.palette.mode === 'light'
                ? 'rgb(55, 65, 81)'
                : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            fontSize: 15,
            padding: "4px 12px",
            '& .MuiSvgIcon-root': {
                fontSize: 16,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity
                ),
            },
        },
    },
}));

const ProformaAccount = () => {
    const [customerData, setCustomerData] = useState({
        customer: "",
        customerOptions: [],
    });
    const [status, setStatus] = useState([lStatusOption[0]]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [location, setLocation] = useState("");
    const [listData, setListData] = useState([]);
    const [salesListLoader, setSalesListLoader] = useState(false);
    const [fetchData, setFetchData] = useState(false);
    const [mainData, setMainData] = useState([]);
    const [stoneId, setStoneId] = useState("");
    const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
    const [errorSnackbar, setErrorSnackbar] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [pdfName, setPdfName] = useState("");
    const [pdfByte, setPdfByte] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fetchUserData, setFetchUserData] = useState(false);
    const [filterValues, setFilterValues] = useState({});
    const [groupBy, setGroupBy] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);
    const [noOfSelectedStones, setNoOfSelectedStones] = useState("0");
    const [selectedTotalSize, setSelectedTotalSize] = useState("0");
    const [selectedAvgDiscount, setSelectedAvgDiscount] = useState("0");
    const [selectedavgPrice, setSelectedavgPrice] = useState("0");
    const [selectedtotalPrice, setSelectedtotalPrice] = useState("0");
    const [stoneMediaURL, setStoneMediaURL] = useState([]);
    const [showStoneMediaModal, setShowStoneMediaModal] = useState(false);
    const [showUserDetailModal, setShowUserDetailModal] = useState(false);
    const [columnNames, setColumnNames] = useState([]);
    const [byProformaExcelData, setByProformaExcelData] = useState([]);

    // eslint-disable-next-line
    const [fullExcelPermission, setFullExcelPermission] = useState(
        Constants.USER_PERMISSION.filter(
            (iPermission) =>
                iPermission.permissionid === Constants.PERMISSIONS.DIRECT_EXCEL_DOWNLOAD_FULL
        )
    );

    let date = new Date(); // Current Date and Time
    const buttonMinWidth = Utility.isReadAllowed(fullExcelPermission) ? "130px" : "100px";

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseButton = () => {
        setAnchorEl(null);
    };

    const access = Constants.USER_PERMISSION.find((iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.REPORT_ACCOUNTS_PROFORMA) !== undefined && Constants.loggedInUser.usertype === "E"

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        PageTitle("REPORT_ACCOUNTS_PROFORMA");
        if (access) {
            getAllLocationData();
            setFromDate(new Date(date.setDate(date.getDate())));
            setToDate(new Date());
        }
    }, []);

    const getAllLocationData = () => {
        LocationProxy.GetAllLocationDetailMini((response) => {
            setAllLocationData(response);
        });
        setFetchUserData(true);
    };

    useEffect(() => {
        if (fetchData) {
            if (customerData.customer) {
                handleSearch();
            }
        }
    }, [fetchData]);

    useEffect(() => {
        if (fetchUserData && location) {
            let locationid = location.value;
            let userid = -1; //will fetch all the customers 
            SalesProxy.GetCustomersCreatedProforma(locationid, userid, Constants.loggedInUser.usertype, (response) => {
                if (response)
                    setAllUserData(response);
            });
        }
    }, [fetchUserData, location]);

    const setAllLocationData = (response) => {
        let optionsArray = [];
        optionsArray.push({ value: -1, label: "-- ANY --" });
        response.forEach((data) => {
            let option = { value: data.id, label: data.name };
            optionsArray.push(option);
        });
        setLocation(optionsArray[0]);
        setLocationOptions(optionsArray);
    }

    const setAllUserData = (response) => {
        let optionsArray = [];
        optionsArray.push({ value: "*", label: "-- ANY --" });
        response.map((data) => {
            let option = { value: data.id, label: data.companyname };
            optionsArray.push(option);
            return true;
        });
        setCustomerData({
            ...customerData,
            customerOptions: optionsArray,
            customer:
                customerData.customer === "" && optionsArray.length > 0
                    ? [optionsArray[0]]
                    : customerData.customer,
        });
        setFetchData(true);
    };

    const handleSearch = () => {

        let tempStatus;
        if (status.find(iStatus => iStatus.value === -1)) {
            tempStatus = lStatusOption.map(iStatus => iStatus.value);
        } else {
            tempStatus = status.map(iStatus => iStatus.value);
        }

        let data = {
            from: dayjs(fromDate).format('YYYY-MM-DD') + "T00:00:00.000Z",
            to: dayjs(toDate).format('YYYY-MM-DD') + "T23:59:59.999Z",
            customerid: fullOptionToValue(customerData.customer),
            status: tempStatus,
            locationid: location.value,
        };
        setSalesListLoader(true);
        SalesProxy.GetAllProformaReport(Constants.loggedInUser.id, Constants.loggedInUser.usertype, data, (response) => {
            if (response) {
                if (response.length > 0) prepareByProformaExcelData(response);
                const uniqueFilterValues = {
                    customercompanyname: Utility.getDistinctOptions(response, "customercompanyname"),
                    status: Utility.getDistinctOptions(response, "status"),
                    exchangecurrency: Utility.getDistinctOptions(response, "exchangecurrency"),
                    user: Utility.getDistinctOptions(response, "userid"),
                    broker: Utility.getDistinctOptions(response, "brokerid"),
                    customer: Utility.getDistinctOptions(response, "customerid"),
                    invoicecustomer: Utility.getDistinctOptions(response, "invoicecustomerid"),
                    tradingcompany: Utility.getDistinctOptions(response, "tradingcompanyid"),
                };

                const combinedFilterValues = {
                    customercompanyname: uniqueFilterValues.customercompanyname,
                    status: uniqueFilterValues.status,
                    exchangecurrency: uniqueFilterValues.exchangecurrency,
                    user: uniqueFilterValues.user.map(value => {
                        const matchingItem = response.find(item => item.userid === value);
                        return matchingItem ? `${value} | ${matchingItem.username}` : [];
                    }),
                    broker: uniqueFilterValues.broker.map(value => {
                        const matchingItem = response.find(item => item.brokerid === value);
                        if (matchingItem) {
                            let displayValue = matchingItem.brokerid === -1 ? " - " : `${matchingItem.brokerid} | ${matchingItem.brokercompanyname}`;
                            return displayValue;
                        }
                        return [];
                    }),
                    customer: uniqueFilterValues.customer.map(value => {
                        const matchingItem = response.find(item => item.customerid === value);
                        return matchingItem ? `${value} | ${matchingItem.customercompanyname}` : [];
                    }),
                    invoicecustomer: uniqueFilterValues.invoicecustomer.map(value => {
                        const matchingItem = response.find(item => item.invoicecustomerid === value);
                        if (matchingItem) {
                            let displayValue = (!matchingItem.invoicecustomerid) ? " - " : `${matchingItem.invoicecustomerid} | ${matchingItem.invoicecustomercompanyname}`;
                            return displayValue;
                        }
                        return [];
                    }),
                    tradingcompany: uniqueFilterValues.tradingcompany.map(value => {
                        const matchingItem = response.find(item => item.tradingcompanyid === value);
                        return matchingItem ? `${value} | ${matchingItem.tradingcompanyname}` : [];
                    }),
                    proformaStatus: [...new Set(response.flatMap(iData => Utility.getDistinctOptions(iData.stones, 'status')))],

                    labshape: [...new Set(response.flatMap(idata => idata.stones.map(i => i.stonedetail.labshape)))],
                };

                setFilterValues(combinedFilterValues);
                let sortedListData = sortData(response);
                setListData(sortedListData);
                handleArray(response);
                prepareColumns();
                setSalesListLoader(false);
                setFetchData(false);
            } else {
                setSalesListLoader(false);
                setErrorSnackbar(true);
            }
        });
    };

    const prepareByProformaExcelData = (response) => {

        let excelData = [...response];
        let locationMap = new Map();

        excelData.forEach(iData => {
            if (!locationMap.has(iData.companylocation)) {
                locationMap.set(iData.companylocation, {
                    locationseq: iData.locationseq,
                    locationname: iData.companylocation, // Add location name if available
                    customers: new Map()
                });
            }

            let location = locationMap.get(iData.companylocation);
            let customerMap = location.customers;

            if (!customerMap.has(iData.customerid)) {
                // If new customer company name, add customer
                customerMap.set(iData.customerid, {
                    customercompanyname: iData.customercompanyname || '',
                    customername: `${iData.customerfirstname || ''} ${iData.customerlastname || ''}`.trim(),
                    customeremail: iData.customeremail || '',
                    employeename: `${iData.userfirstname || ''} ${iData.userlastname || ''}`.trim(),
                    brokername: `${iData.brokerfirstname || ''} ${iData.brokerlastname || ''}`.trim(),
                    locationseq: iData.locationseq,
                    stones: iData.stones.map(iStone => ({ ...iStone, days: iData.days, exchangerate: iData.exchangerate, remarks: iData.remarks }))
                })
            } else {
                const existing = customerMap.get(iData.customerid);
                existing.stones.push(...iData.stones.map(iStone => ({ ...iStone, days: iData.days, exchangerate: iData.exchangerate, remarks: iData.remarks })));
            }
        })

        let finalData = Array.from(locationMap.values()).map(location => {
            let customersArray = Array.from(location.customers.values()).sort((a, b) => {
                return a.customercompanyname.localeCompare(b.customercompanyname);
            });

            // Sort stones inside each customer
            customersArray.forEach(customer => {
                customer.stones.sort((a, b) => b.stonedetail.stonetype.localeCompare(a.stonedetail.stonetype));
            });

            return {
                locationseq: location.locationseq,
                locationname: location.locationname,
                customers: customersArray
            };
        });

        // Optional: Sort locations by locationseq (or locationname)
        finalData.sort((a, b) => a.locationseq - b.locationseq);

        setByProformaExcelData(finalData);
    }

    const createExcelFileByProforma = () => {

        const workbook = XLSX.utils.book_new();

        // Define headers
        const headers = [
            "PROF ID", "REPORT", "SHAPE", "STONE ID", "STONETYPE", "CARAT", "COLOR", "COLOR DESCRIPTIONS", "CLARITY", "CUT", "POL", "SYM",
            "FLO", "DAYS", "DIS", "RAP", "LAB", "LOCATION", "PPC", "TOTAL", "SOLD BY", "SHADE", "EX RATE", "BROKER", "REMARKS", "ADD/LESS %"
        ];

        // Columns that should be right-aligned
        const rightAlignColumns = ["CARAT", "DIS", "RAP", "PPC", "TOTAL"];

        byProformaExcelData.forEach(location => {
            const sheetData = [];
            const merges = [];

            sheetData.push(headers); // Add header row
            let currentRow = 1;

            location.customers.forEach(customer => {
                const customerInfo = `${customer.customercompanyname.toUpperCase()}  (${customer.customername.toUpperCase()} - - ${customer.customeremail})`;

                // Add an empty row before customer info
                const emptyRow = new Array(26).fill("");
                sheetData.push(emptyRow);
                currentRow++;

                // Add customer info row
                const customerRow = new Array(26).fill("");
                customerRow[0] = customerInfo;
                sheetData.push(customerRow);

                // Merge the customer info row across all columns
                merges.push({
                    s: { r: currentRow, c: 0 },
                    e: { r: currentRow, c: headers.length - 1 }
                });

                currentRow++;

                // Add stone rows
                customer.stones.forEach(stone => {
                    sheetData.push([
                        stone.perfomaid,
                        stone.stonedetail.certificateid,
                        stone.stonedetail.shape,
                        stone.stoneid,
                        Constants.STONE_TYPE[stone.stonedetail.stonetype],
                        Utility.ConvertNumberWithSpecifiedDigits(stone.stonedetail.size, 2),
                        stone.stonedetail.color,
                        stone.stonedetail.colordescriptions,
                        stone.stonedetail.clarity,
                        stone.stonedetail.cut,
                        stone.stonedetail.pol,
                        stone.stonedetail.sym,
                        stone.stonedetail.flo,
                        stone.days,
                        Utility.ConvertNumberWithSpecifiedDigits(stone.actualdiscount, 2),
                        stone.originalprice,
                        stone.stonedetail.lab,
                        location.locationname,
                        Utility.ConvertNumberWithSpecifiedDigits(stone.discountprice, 2),
                        Utility.ConvertNumberWithSpecifiedDigits(stone.stoneprice, 2),
                        customer.employeename,
                        stone.stonedetail.shade,
                        stone.exchangerate,
                        customer.brokername,
                        stone.remarks,
                        stone.addlesspercent
                    ]);
                    currentRow++;
                });
            });

            const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
            worksheet["!merges"] = merges;

            // Define borders
            const borderStyle = {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } }
            };

            // Apply styles to all cells
            const range = XLSX.utils.decode_range(worksheet["!ref"]);
            for (let R = range.s.r; R <= range.e.r; ++R) {
                for (let C = range.s.c; C <= range.e.c; ++C) {
                    const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
                    if (!worksheet[cellRef]) worksheet[cellRef] = { v: "" };

                    const headerName = headers[C] || "";

                    // Determine alignment
                    const alignRight = rightAlignColumns.includes(headerName);
                    const isHeaderRow = R === 0;

                    worksheet[cellRef].s = {
                        font: {
                            name: "Cambria",
                            sz: 11,
                            bold: isHeaderRow
                        },
                        alignment: {
                            vertical: "center",
                            horizontal: alignRight ? "right" : "center"
                        },
                        fill: isHeaderRow ? { fgColor: { rgb: "4f81bd" } } : undefined,
                        border: borderStyle
                    };

                    if (isHeaderRow) {
                        worksheet[cellRef].s.font.color = { rgb: "FFFFFF" };
                        worksheet[cellRef].s.alignment.horizontal = "center";
                    }
                }
            }

            // Bold merged customer rows
            merges.forEach(merge => {
                const cellRef = XLSX.utils.encode_cell(merge.s);
                if (worksheet[cellRef]) {
                    worksheet[cellRef].s.font.bold = true;
                    worksheet[cellRef].s.alignment.horizontal = "left";
                    worksheet[cellRef].s.fill = { fgColor: { rgb: "d8e4bc" } };
                }
            });

            XLSX.utils.book_append_sheet(workbook, worksheet, location.locationname);
        });

        // Write the file
        XLSX.writeFile(workbook, "AccountProformaReport.xlsx");
    };

    const sortData = (listData) => {
        return listData.sort((a, b) => b.id - a.id)
    }

    const prepareColumns = () => {
        let columnNames = [];
        columnNames.push(
            {
                field: "perfomaid",
                headerName: "PROF. ID",
                headerAlign: "center",
                width: 70,
                type: "number",
                valueFormatter: (params) => params.value,
                align: "center",
            },
            {
                field: "customercompanyname",
                headerName: "CUSTOMER COMPANY NAME",
                headerAlign: "center",
                align: "center",
                width: 200,
                renderCell: renderCellExpand,
            },
            {
                field: "stonetransitstatus",
                headerName: "TRANSIT STATUS",
                headerAlign: "center",
                width: 155,
                align: "center",
                renderCell: (params) => params.value === null ? " - " :
                    (params.value === "NEW" && params.row.tradingcompanylocation === params.row.stonelocation ?
                        (params.row.stoneoldstatus !== null ? Constants.STONE_TRANSIT_STATUS[params.row.stoneoldstatus] : Constants.STONE_TRANSIT_STATUS["RECEIVED"]) :
                        Constants.STONE_TRANSIT_STATUS[params.value])
            }
        );

        Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
            if (columnsData.hasOwnProperty(iColPermission)) {
                const columnData = columnsData[iColPermission];
                columnNames.push(columnData);
                if (columnData.field === "stoneid") {
                    columnNames.push({
                        field: "suratid",
                        headerName: "REF NO",
                        headerAlign: "center",
                        align: "center",
                        width: 90,
                        renderCell: renderCellExpand,
                    });
                }
            }
        });
        setColumnNames(columnNames);
    }

    const handleSelection = (data) => {
        let matchedRecords = mainData.filter(iData => data.includes(iData.performaid_stoneid));
        let unMatchedRecords = mainData.filter(iData => !data.includes(iData.performaid_stoneid));

        setMainData([...matchedRecords, ...unMatchedRecords]);
        setSelectionModel(data);
    }

    const fullOptionToValue = (selectedData) => {
        let newArr = [];
        selectedData.map((data) => {
            if (data.value === "*") {
                return customerData.customerOptions.map((option) => {
                    if (option.value !== "*") {
                        newArr.push(option.value);
                        return true;
                    }
                    return true;
                });
            }
            return true;
        })
        return Utility.GetValueArrayWithStarReplace(selectedData, newArr);
    };

    const downloadPDF = (proformaid, fileBytes) => {
        setPdfByte(fileBytes);
        setPdfName(`Profroma_` + proformaid + `.pdf`);
        openModal()
    }

    const handleArray = (lListData) => {
        let newMainData = [];
        if (lListData.length > 0) {
            lListData.map((list) => {
                list.stones.map((stone) =>
                    newMainData.push({
                        performaid_stoneid: stone.perfomaid + "_" + stone.stoneid,
                        perfomaid: stone.perfomaid,
                        stoneid: stone.stoneid,
                        stoneprice: stone.stoneprice,
                        discount: stone.actualdiscount,
                        discountprice: stone.discountprice,
                        originalprice: stone.originalprice,
                        proformastatus: stone.status,
                        stonestatus: stone.stonedetail.status,
                        clarity: stone.stonedetail.clarity,
                        certificateid: stone.stonedetail.certificateid,
                        color: stone.stonedetail.color,
                        colordescriptions: stone.stonedetail.colordescriptions,
                        country: stone.stonedetail.country,
                        cut: stone.stonedetail.cut,
                        cutpolsym: stone.stonedetail.cutpolsym,
                        flo: stone.stonedetail.flo,
                        lab: stone.stonedetail.lab,
                        location: stone.stonedetail.location,
                        locationid: stone.stonedetail.locationid,
                        pol: stone.stonedetail.pol,
                        quality: stone.stonedetail.quality,
                        shade: stone.stonedetail.shade,
                        shape: stone.stonedetail.shape,
                        size: stone.stonedetail.size,
                        exchangerate: list.exchangerate,
                        shippingcost: list.shippingcost,
                        stonelocation: stone.stonelocation,
                        sym: stone.stonedetail.sym,
                        stonetransitstatus: stone.stonetransitstatus,
                        tradingcompanylocation: list.companylocation,
                        customercompanyname: list.customercompanyname,
                        stonetype: stone.stonedetail.stonetype,
                        depth: stone.stonedetail.depth,
                        depthpercent: stone.stonedetail.depthpercent,
                        measurements: stone.stonedetail.measurements,
                        tablepercent: stone.stonedetail.tablepercent,
                        crownangle: stone.stonedetail.crownangle,
                        stonemediaurl: stone.stonedetail.stonemediaurl,
                        lrhalf: stone.stonedetail.lrhalf,
                        comment: stone.stonedetail.comment,
                        fancycolor1: stone.stonedetail.fancycolor1,
                        length: stone.stonedetail.length,
                        tinge: stone.stonedetail.tinge,
                        milky: stone.stonedetail.milky,
                        fancycolorintensity: stone.stonedetail.fancycolorintensity,
                        fancycolorovertone: stone.stonedetail.fancycolorovertone,
                        open: stone.stonedetail.open,
                        strln: stone.stonedetail.strln,
                        age: stone.stonedetail.age,
                        keytosymbols: stone.stonedetail.keytosymbols,
                        h_and_a: stone.stonedetail.h_and_a,
                        eyeclean: stone.stonedetail.eyeclean,
                        tableinc: stone.stonedetail.tableinc,
                        sideinc: stone.stonedetail.sideinc,
                        luster: stone.stonedetail.luster,
                        tableblack: stone.stonedetail.tableblack,
                        sideblack: stone.stonedetail.sideblack,
                        labshape: stone.stonedetail.labshape,
                        colortype: stone.stonedetail.colortype,
                    })
                );
                return true;
            });
        }
        setMainData(newMainData);
        loadTotalData(newMainData);
    };

    useEffect(() => {
        if (selectionModel.length <= 0) {
            loadTotalData(mainData);
            return;
        }
        let totalSize = 0;
        let totalPrice = 0;   //ppc*size
        let total = 0;       //rapnetprice*size
        mainData.forEach((iData) => {
            if (selectionModel.includes(iData.performaid_stoneid)) {
                let pricePerCarat = iData.discountprice
                totalSize += iData.size;
                totalPrice += (iData.stoneprice);
                total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));
            }
        });
        setNoOfSelectedStones(selectionModel.length);
        setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
        setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
        setSelectedavgPrice(totalPrice > 0 ?
            Utility.ConvertNumberWithSpecifiedDigits(totalPrice / totalSize) :
            Utility.ConvertNumberWithSpecifiedDigits(0));
        setSelectedAvgDiscount(totalPrice > 0 ?
            Utility.ConvertNumberWithSpecifiedDigits((100 - (totalPrice / total) * 100) * -1) :
            Utility.ConvertNumberWithSpecifiedDigits(0)
        );
    }, [selectionModel]);

    const loadTotalData = (data) => {
        let totalSize = 0;
        let totalPrice = 0;   //ppc*size
        let total = 0;       //rapnetprice*size

        data.forEach((iData) => {
            let pricePerCarat = iData.discountprice;
            totalSize += iData.size;
            totalPrice += (iData.stoneprice);
            total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));

        });
        setNoOfSelectedStones(data.length);
        setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
        setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
        setSelectedavgPrice(
            totalPrice > 0
                ? Utility.ConvertNumberWithSpecifiedDigits(
                    totalPrice / totalSize
                )
                : Utility.ConvertNumberWithSpecifiedDigits(0)
        );
        setSelectedAvgDiscount(
            totalPrice > 0
                ? Utility.ConvertNumberWithSpecifiedDigits(
                    (100 - (totalPrice / total) * 100) * -1
                )
                : Utility.ConvertNumberWithSpecifiedDigits(0)
        );
    };

    const handleStoneDetailModal = (params) => {
        setStoneId(params.value);
        setShowStoneDetailModal(true);
    };

    const columnsData = {
        "8eaa8a03-d163-436d-8912-51ea06306f44": {
            field: "certificateid",
            headerName: "CERT",
            headerAlign: "center",
            align: "center",
            width: 90,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "52599510-9698-4cd3-90b7-7ac22b6af7e2": {
            field: "stonetype",
            headerName: "STONETYPE",
            headerAlign: "center",
            align: "center",
            width: 100,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => Constants.STONE_TYPE[params.value],
            renderCell: (params) => Constants.STONE_TYPE[params.value],
        },
        "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
            field: "shape",
            headerName: "SHAPE",
            headerAlign: "center",
            align: "center",
            width: 80,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.shape.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
            field: "stoneid",
            headerName: "STONEID",
            headerAlign: "center",
            width: 80,
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
                <Button
                    sx={{ textDecorationLine: "underline" }}
                    onClick={() => handleStoneDetailModal(params)}
                >
                    {params.value}
                </Button>
                :
                <div>{params.value}</div>,
        },

        "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
            field: "size",
            headerName: "SIZE",
            headerAlign: "center",
            width: 40,
            align: "right",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size)
        },
        "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
            field: "color",
            headerName: "COLOR",
            headerAlign: "center",
            align: "center",
            width: 65,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.color.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "d4992de9-92ab-4f9e-ba12-6c746e935611": {
            field: "colordescriptions",
            headerName: "COLOR DESCRIPTIONS",
            headerAlign: "center",
            align: "center",
            width: 160,
            renderCell: renderCellExpand,
        },
        "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
            field: "clarity",
            headerName: "CLARITY",
            headerAlign: "center",
            align: "center",
            width: 75,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.clarity.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "3597803f-8932-40c6-8de6-81006f4d6d5b": {
            field: "cut",
            headerName: "CUT",
            headerAlign: "center",
            align: "center",
            width: 50,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.cut.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
            field: "pol",
            headerName: "POL",
            headerAlign: "center",
            align: "center",
            width: 40,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.pol.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "5541c182-21b8-496e-b342-b0b89f3d302f": {
            field: "sym",
            headerName: "SYM",
            headerAlign: "center",
            align: "center",
            width: 40,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.sym.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "8296e627-0be5-4a66-830f-ea6867cea137": {
            field: "flo",
            headerName: "FLO",
            headerAlign: "center",
            align: "center",
            width: 60,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.flo.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "798a8663-0f0c-41be-8512-16dd60d5f25e": {
            field: "discount",
            headerName: "DIS",
            headerAlign: "center",
            align: "center",
            width: 70,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
        },
        "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
            field: "originalprice",
            headerName: "RAP",
            headerAlign: "center",
            align: "center",
            width: 70,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
        },
        "39c634f1-2644-4307-acbb-983b4de4229e": {
            field: "discountprice",
            headerName: "PPC",
            headerAlign: "center",
            align: "center",
            width: 70,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
        },
        "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
            field: "stoneprice",
            headerName: "TOTAL",
            headerAlign: "center",
            align: "center",
            width: 70,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
        },
        "ab3e506e-bddb-456d-b967-922dcee74d56": {
            field: "stonelocation",
            headerName: "LOCATION",
            headerAlign: "center",
            align: "center",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            width: 100,
        },
        "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
            field: "lab",
            headerName: "LAB",
            headerAlign: "center",
            align: "center",
            width: 40,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.lab.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "cf694b75-ba5d-4a73-8fcf-e7566974c4b6": {
            field: "media",
            headerName: "MEDIA",
            headerAlign: "center",
            align: "center",
            width: 60,
            renderCell: (params) => (
                <Tooltip title={"Stone Media"} sx={{ cursor: "pointer" }}>
                    <VideoLibraryTwoToneIcon
                        sx={{ cursor: "pointer" }}
                        onClick={() => {
                            setStoneMediaURL(params.row.stonemediaurl);
                            setShowStoneMediaModal(true);
                        }} />
                </Tooltip>
            ),
        },
        "13d48508-b8c9-4661-8a6c-9fb22a3408a3": {
            field: "measurements",
            headerName: "MEASUREMENTS",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 140,
            renderCell: renderCellExpand,
        },
        "567202e6-c31c-4c19-9998-1cacae05af6e": {
            field: "depth",
            headerName: "DEPTH",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 70,
            renderCell: renderCellExpand,
        },
        "66dfbc62-477f-42f0-8097-56c5d8329156": {
            field: "lrhalf",
            headerName: "LR HALF",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 120,
        },
        "e5c1f34e-6e1c-4ee8-bb8e-3236716fd1ff": {
            field: "depthpercent",
            headerName: "DEPTH %",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 70,
            renderCell: renderCellExpand,
        },
        "70498a64-1f5f-4f03-8910-a6d7851e4aba": {
            field: "tablepercent",
            headerName: "TABLE%",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 75,
            renderCell: renderCellExpand,
        },
        "706a5cfb-e196-43d1-bbe3-c52aad9a46c1": {
            field: "comment",
            headerName: "COMMENT",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "77e48fa7-d118-4ab8-865b-9b85b32a004f": {
            field: "fancycolor1",
            headerName: "F.COLOR",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "a1299782-d545-4d70-bcbc-7d576e396d64": {
            field: "length",
            headerName: "LENGTH",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 120,
        },
        "b38b9fdf-bfb8-43c6-82a2-1e366fa71523": {
            field: "tinge",
            headerName: "TINGE",
            headerAlign: "center",
            align: "center",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.tinge.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            width: 120,
        },
        "c4e65984-1682-4c1e-812b-8938e9078b2d": {
            field: "crownangle",
            headerName: "CR.ANG",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        "c95089ee-166d-4783-817c-2638f6d40df1": {
            field: "milky",
            headerName: "MILKY",
            headerAlign: "center",
            align: "center",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.milky.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            width: 120,
        },
        "c9aa6ee7-30e3-423e-a534-80bb5ef7bbaf": {
            field: "fancycolorintensity",
            headerName: "F.COL.INTENSITY",
            headerAlign: "center",
            align: "center",
            width: 140,
            renderCell: renderCellExpand,
        },
        "ccba9873-174e-4060-963a-9893c3625bb2": {
            field: "fancycolorovertone",
            headerName: "OVERTONE",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "db078198-4416-4d53-b3d0-70d3a5418f65": {
            field: "open",
            headerName: "OPEN",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        "dfd5488a-b600-4e75-9735-98c26f78dc84": {
            field: "strln",
            headerName: "STAR LENGTH",
            headerAlign: "center",
            align: "center",
            width: 120,
        },
        "e32fe363-07cc-4307-82d2-82ae1069b5be": {
            field: "age",
            headerName: "AGE",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            valueGetter: (params) => {
                if (params.value)
                    return Utility.ConvertDateToAge(params.value);
                else
                    return null;
            },
            renderCell: (params) => {
                return params.value;
            },
        },
        "e683145c-29dd-4d41-af1a-518ff80090d2": {
            field: "keytosymbols",
            headerName: "KEY TO SYMBOLS",
            headerAlign: "center",
            align: "center",
            width: 120,
        },
        "e993a4f7-7c50-4d83-abae-fccc03382742": {
            field: "h_and_a",
            headerName: "H&A",
            headerAlign: "center",
            align: "center",
            width: 120,
        },
        "f2fe7666-6489-40ce-b4b7-040c68c88bf3": {
            field: "eyeclean",
            headerName: "EYE CLEAN",
            headerAlign: "center",
            align: "center",
            width: 120,
        },
        "f3223657-c8d2-449c-b2f5-5a54c78401ce": {
            field: "tableinc",
            headerName: "TABLE INC",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 120,
        },
        "f114ad2c-8560-4da7-9b03-03ba6bfe39a5": {
            field: "sideinc",
            headerName: "SIDE INC",
            headerAlign: "center",
            align: "center",
            width: 120,
        },
        "2a6475ff-481f-48c6-9e92-3ede0b97d7c0": {
            field: "luster",
            headerName: "LUSTER",
            headerAlign: "center",
            align: "center",
            width: 120,
        },
        "556ae429-3605-4df4-88d8-b5223fc2e2fb": {
            field: "tableblack",
            headerName: "TABLE BLACK",
            headerAlign: "center",
            align: "center",
            type: "boolean",
            width: 120,
        },
        "5c70d1ca-2a7b-4660-8160-0beff7ad1150": {
            field: "sideblack",
            headerName: "SIDE BLACK",
            headerAlign: "center",
            align: "center",
            type: "boolean",
            width: 120,
        },
        "62c37a29-d2ff-4c72-8cb3-07e52a83d484": {
            field: "status",
            headerName: "STATUS",
            headerAlign: "center",
            align: "center",
            width: 100,
            renderCell: renderCellExpand,
        },
    };

    const materialDefaultColumns = [
        {
            headerName: "PDF",
            field: "performapdf",
            renderCell: (params) => (
                <BsFilePdf size={25} color="red" onClick={() => downloadPDF(params.row.id, params.row.performapdf)} />
            ),
            export: false,
            headerAlign: "center",
            align: "center",
            width: 55
        },
        {
            headerName: "PROF. ID",
            field: "id",
            headerAlign: "center",
            width: 95,
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            renderCell: renderCellExpand
        },
        {
            headerName: "STATUS",
            field: "status",
            width: 80,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.status : [],
            filterOperators: Utility.combinedFilters(),
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand
        },
        {
            headerName: "STONETYPE",
            field: "stonetype",
            headerAlign: "center",
            align: "center",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => Constants.STONE_TYPE[params.value],
            renderCell: (params) => Constants.STONE_TYPE[params.value],
            width: 95,
        },
        {
            headerName: "DATE",
            field: "date",
            type: "date",
            width: 75,
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalDate(params.row.date),
            headerAlign: "center",
            align: "center",
        },
        {
            headerName: "CUSTOMER COMPANY",
            field: "customerid",
            width: 200,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.customer : [],
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => {
                return `${params.row.customerid} | ${params.row.customercompanyname}`;
            },
            renderCell: (params) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                            {`${params.row.customerid} | ${params.row.customercompanyname}`}
                        </span>
                    </div>
                );
            },
            headerAlign: "center",
            align: "center",
        },
        {
            headerName: "BROKER COMPANY",
            field: "brokerid",
            width: 150,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.broker : [],
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => {
                return params.row.brokerid === -1 ? " - " : `${params.row.brokerid} | ${params.row.brokercompanyname}`;
            },
            renderCell: (params) => {
                let displayValue = params.row.brokerid === -1 ? " - " : `${params.row.brokerid} | ${params.row.brokercompanyname}`
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                            {displayValue}
                        </span>
                    </div>
                );
            },
            headerAlign: "center",
            align: "center",
        },
        {
            headerName: "EXCHANGE RATE",
            field: "exchangerate",
            headerAlign: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            width: 120,
            renderCell: renderCellExpand
        },
        {
            headerName: "FINAL PAYABLE AMT",
            field: "finalpayableamount",
            headerAlign: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            width: 135,
            renderCell: renderCellExpand
        },
        {
            headerName: "TRADING COMPANY",
            field: "tradingcompanyid",
            width: 175,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.tradingcompany : [],
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => {
                return `${params.row.tradingcompanyid} | ${params.row.tradingcompanyname}`;
            },
            renderCell: (params) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                            {`${params.row.tradingcompanyid} | ${params.row.tradingcompanyname}`}
                        </span>
                    </div>
                );
            },
            headerAlign: "center",
            align: "center",
        },
        {
            headerName: "USER",
            field: "userid",
            width: 145,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.user : [],
            filterOperators: Utility.combinedFilters(),
            headerAlign: "center",
            align: "center",
            valueGetter: (params) => {
                return `${params.row.userid} | ${params.row.username}`;
            },
            renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                        {`${params.row.userid} | ${params.row.username}`}
                    </span>
                </div>
            ),
        },
        {
            headerName: "CUSTOMER INVOICE COMPANY",
            field: "invoicecustomerid",
            width: 215,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.invoicecustomer : [],
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => {
                return (!params.row.invoicecustomerid) ? " - " : `${params.row.invoicecustomerid} | ${params.row.invoicecustomercompanyname}`;
            },
            renderCell: (params) => {
                let displayValue = (!params.row.invoicecustomerid) ? " - " : `${params.row.invoicecustomerid} | ${params.row.invoicecustomercompanyname}`
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                            {displayValue}
                        </span>
                    </div>
                );
            },
            headerAlign: "center",
            align: "center",
        },
        {
            headerName: "TRADING COMPANY LOCATION",
            field: "companylocation",
            headerAlign: "center",
            type: "singleSelect",
            width: 200,
            valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            align: "center",
        },
        {
            headerName: "BANK THROUGH",
            field: "bankthrough",
            renderCell: (params) =>
                params.row.bankthrough ? (
                    <CheckIcon color="success" />
                ) : (
                    <ClearIcon color="error" />
                ),
            headerAlign: "center",
            width: 200,
            align: "center",
        },
        {
            headerName: "COUNTRY OF FINAL DESTINATION",
            field: "countryoffinaldestination",
            headerAlign: "center",
            align: "center",
            width: 200,
            renderCell: renderCellExpand
        },
        {
            headerName: "COUNTRY OF ORIGIN",
            field: "countryoforigin",
            headerAlign: "center",
            width: 200,
            align: "center",
            renderCell: renderCellExpand
        },
        {
            headerName: "ENSURED BY",
            field: "ensuredby",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand
        },
        {
            headerName: "EXCHANGE CURRENCY",
            field: "exchangecurrency",
            headerAlign: "center",
            align: "center",
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.exchangecurrency : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand
        },
        {
            headerName: "EXPORT",
            field: "export",
            renderCell: (params) =>
                params.row.export ? (
                    <CheckIcon color="success" />
                ) : (
                    <ClearIcon color="error" />
                ),
            headerAlign: "center",
            align: "center",
        },
        {
            headerName: "FINAL DESTINATION",
            field: "finaldestination",
            headerAlign: "center",
            align: "center",
            width: 200,
            renderCell: renderCellExpand
        },
        {
            headerName: "PORT OF DISCHARGE",
            field: "portofdischarge",
            headerAlign: "center",
            align: "center",
            width: 200,
            renderCell: renderCellExpand
        },
        {
            headerName: "PORT OF LANDING",
            field: "portofloading",
            headerAlign: "center",
            align: "center",
            width: 200,
            renderCell: renderCellExpand
        },
        {
            headerName: "REMARKS",
            field: "remarks",
            headerAlign: "center",
            align: "center",
            width: 300,
            renderCell: renderCellExpand
        },
        {
            headerName: "SHIPPED BY",
            field: "shippedby",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand
        },
        {
            headerName: "SHIPPING COST",
            field: "shippingcost",
            headerAlign: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            width: 200,
            renderCell: renderCellExpand
        },
        {
            headerName: "TERMS",
            field: "terms",
            headerAlign: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            renderCell: renderCellExpand
        },
        {
            headerName: "DAYS",
            field: "days",
            headerAlign: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            renderCell: (params) => params.value,
        },
        {
            headerName: "DUE DATE",
            field: "duedate",
            type: "date",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalDate(params.row.duedate),
            headerAlign: "center",
            align: "center",
        },
    ];

    const getSummaryData = (rowdata) => {

        let data = [];
        if (selectionModel && selectionModel.length > 0) {
            data = rowdata.filter((data) => selectionModel.includes(data.stoneid));
        } else {
            data = rowdata;
        }

        let noOfStones = 0;
        let totalSize = 0;
        let totalAmount = 0;
        let total = 0;

        data.forEach(item => {
            noOfStones += 1;

            if (Utility.isValueValid(item.size)) {
                totalSize += Number(item.size);
            }

            if (Utility.isValueValid(item.stoneprice)) {
                totalAmount += Number(item.stoneprice);
            }

            if (
                Utility.isValueValid(item.discountprice) &&
                Utility.isValueValid(item.discount) &&
                Utility.isValueValid(item.size)
            ) {
                const effectivePrice = (100 * Number(item.discountprice)) / (100 + Number(item.discount));
                total += Number(item.size) * effectivePrice;
            }
        });

        return {
            ID: noOfStones,
            CTS: (Number(totalSize)).toFixed(2),
            DIS: (Number((100 - (totalAmount / total) * 100) * -1)).toFixed(2),
            PPC: (Number(totalAmount / totalSize)).toFixed(2),
            TOTAL: (Number(totalAmount)).toFixed(2),
        };
    }

    const getExcelData = (rowdata, fullExcel) => {
        let data = [];

        if (selectionModel && selectionModel.length > 0) {
            data = rowdata.filter((data) => selectionModel.includes(data.performaid_stoneid));
        } else {
            data = rowdata;
        }

        const excelData = data.map(item => {

            return {
                REPORT: item.certificateid,
                SHAPE: item.shape,
                ID: item.stoneid,
                CTS: item.size,
                COL: item.colortype === "WHITE" ? item.color : item.colordescriptions,
                CLA: item.clarity,
                CUT: item.cut ? item.cut : " ",
                POL: item.pol,
                SYM: item.sym,
                FLR: item.flo,
                MEASUREMENTS: item.measurements,
                DEP: !item.depthpercent ? "" : (Number(item.depthpercent)).toFixed(2),
                "TABLE%": !item.tablepercent ? "" : (Number(item.tablepercent)).toFixed(2),
                "CR ANG": !item.crownangle ? "" : (Number(item.crownangle)).toFixed(2),
                LAB: item.lab,
                RAP: item.originalprice,
                DIS: parseFloat((Number(item.discount)).toFixed(2)),
                PPC: parseFloat((Number(item.discountprice)).toFixed(2)),
                TOTAL: parseFloat((Number(item.stoneprice)).toFixed(2)),
                LOCATION: item.location,
                STATUS: item.status,
                KEYTOSYMBOLS: item.keytosymbols ? item.keytosymbols : " ",
                MEDIA: {
                    t: "s",
                    v: "Media URL",
                    l: {
                        Target: item.stonemediaurl,
                        Tooltip: "Click to open images & videos",
                    }, TOTAL: (Number(item.total)).toFixed(2),
                },
                holdstonecustomerid: item.holdstonecustomerid,
                holdstoneuserid: item.holdstoneuserid,
                holdstonebrokerid: item.holdstonebrokerid,
                TABLEINC: item.tableinc ? item.tableinc : "",
                SIDEINC: item.sideinc ? item.sideinc : "",
                H_AND_A: item.h_and_a ? item.h_and_a : "",
                EYECLEAN: item.eyeclean ? item.eyeclean : "",
                TINGE: item.tinge ? item.tinge : "",
                MILKY: item.milky ? item.milky : "",
                OPEN: item.open ? item.open : "",
                LUSTER: item.luster ? item.luster : "",
                TABLEBLACK: item.tableblack ? "YES" : "NO",
                SIDEBLACK: item.sideblack ? "YES" : "NO",
            };
        });

        const calculatedRow = getSummaryData(rowdata);

        //addding last row for summary data
        const lastRow = Object.fromEntries(
            Constants.STOCK_EXCEL_KEYS.map(key => [key, calculatedRow[key] || ""])
        );

        //addding last row for summary data
        excelData.push(lastRow);

        const exportColumns = fullExcel
            ? [...Constants.STOCK_EXCEL_COLUMNS, ...Constants.EXCEL_OPTIONAL_COLUMNS]
            : Constants.STOCK_EXCEL_COLUMNS;

        createExcelFile(excelData, null, exportColumns, "PI-Stock.xlsx");
    }

    const getDetailPanelContent = React.useCallback((row, mainData, columns) =>
        <DetailPanelContent row={row} mainData={mainData} columns={columns} />,
        [],
    );

    function DetailPanelContent({ row: rowProp, mainData, columns }) {
        const [anchorEl1, setAnchorEl1] = React.useState(null);
        const open1 = Boolean(anchorEl1);
        const handleClick = (event) => {
            setAnchorEl1(event.currentTarget);
        };
        const handleCloseButton = () => {
            setAnchorEl1(null);
        };
        let row = mainData.filter(data => data.perfomaid === rowProp.id).sort((a, b) => a.stoneid - b.stoneid);

        let totalSize = 0;
        let totalPrice = 0;   //ppc*size
        let total = 0;       //rapnetprice*size

        row.forEach((iData) => {
            let pricePerCarat = iData.discountprice;
            totalSize += iData.size;
            totalPrice += (iData.stoneprice);
            total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));
        });

        let noOfSelectedStones = row.length;
        let selectedTotalSize = Utility.ConvertNumberWithSpecifiedDigits(totalSize);
        let selectedtotalPrice = Utility.ConvertNumberWithSpecifiedDigits(totalPrice);
        let selectedavgPrice = totalPrice > 0 ?
            Utility.ConvertNumberWithSpecifiedDigits(totalPrice / totalSize) :
            Utility.ConvertNumberWithSpecifiedDigits(0);
        let selectedAvgDiscount = totalPrice > 0 ?
            Utility.ConvertNumberWithSpecifiedDigits((100 - (totalPrice / total) * 100) * -1) :
            Utility.ConvertNumberWithSpecifiedDigits(0);

        return (
            <Stack
                sx={{ p: 1, height: '100%', boxSizing: 'border-box', borderBottom: "1px solid lightgrey" }}
                direction="column"
            >
                <Box
                    sx={{
                        backgroundColor: '#fff',
                        color: '#000',
                        width: "92vw",
                        position: "relative",
                        "& .MuiTablePagination-selectLabel": {
                            marginTop: "15px",
                        },
                        "& .MuiTablePagination-displayedRows": {
                            marginTop: "15px",
                        },
                        "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                            fontWeight: Constants.defaultFontWeight,
                        },
                        "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                            color: "#1976d2",
                            padding: "4px 5px",
                            borderRadius: "4px",
                        },
                        "& .css-cc8tf1": {
                            fontWeight: Constants.defaultFontWeight,
                        },
                        height: 'auto',
                    }}
                >
                    <DataGridPro
                        disableRowSelectionOnClick={false}
                        density="compact"
                        columns={columns}
                        rows={row}
                        getRowId={(row) => row.stoneid}
                        sx={{
                            '& .MuiDataGrid-columnHeader': {
                                color: '#fff',
                                backgroundColor: 'grey',
                            },
                            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                py: "4px",
                            },
                            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                py: "12px",
                            },
                            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                py: "18px",
                            },

                            fontSize: Constants.defaultTableFontSize, fontWeight: 'bold',
                            maxHeight: '35vh'
                        }}
                        slots={{ toolbar: GridToolbar }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: { debounceMs: 500 },
                            },
                        }}
                        initialState={{
                            columns: {
                                columnVisibilityModel: {
                                    // Hide columns id, the other columns will remain visible
                                    customercompanyname: false
                                },
                            },
                            pagination: {
                                paginationModel: Constants.pageSize,
                            },
                        }}
                        pageSizeOptions={Constants.pageSizeOptions}
                        pagination
                    />
                </Box>
                <Box
                    sx={{
                        position: "absolute",
                        top: "14px",
                        left: "15%",
                        display: 'flex',
                        alignItems: 'center',
                        width: "14%",
                        color: "black",
                        fontWeight: 'normal',
                        fontSize: Constants.defaultTableFontSize
                    }}
                >
                    <span>No of Stones: </span> <b>{noOfSelectedStones}</b> &nbsp;&nbsp;|&nbsp;&nbsp;
                    <span>Total Weight: </span> <b>{selectedTotalSize}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                    <span>Total Price: </span> <b>{selectedtotalPrice}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                    <span>Avg Price: </span> <b>{selectedavgPrice}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                    <span>Avg Discount: </span> <b>{selectedAvgDiscount}</b>
                    <Box
                        sx={{
                            alignItems: "center",
                            ml: "115px",
                        }}
                    >
                        {!Utility.isReadAllowed(fullExcelPermission) ? (
                            <Button
                                component="label"
                                variant="outlined"
                                size="small"
                                color="secondary"
                                sx={{ ml: "5px", }}
                                startIcon={<Download size="large" />}
                                onClick={() => getExcelData(row, false)}
                            >
                                EXCEL
                            </Button>
                        ) : (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    marginLeft: "5px",
                                    "& .MuiButton-startIcon": {
                                        marginRight: "0px !important",
                                        marginLeft: "-2px",
                                    },
                                    "& .MuiLoadingButton-loadingIndicator": { left: "7px" },
                                }}
                            >
                                <LoadingButton
                                    id="demo-customized-export-menu"
                                    aria-controls={
                                        open1 ? "demo-customized-export-menu" : undefined
                                    }
                                    aria-haspopup="true"
                                    aria-expanded={open1 ? "true" : undefined}
                                    variant="outlined"
                                    disableElevation
                                    onClick={handleClick}
                                    sx={{
                                        color: "#2e7d32",
                                        borderRadius: "4px",
                                        border: "1px solid rgba(46, 125, 50, 0.5)",
                                        padding: "2px 2px 2px 8px",
                                        cursor: "pointer",
                                    }}
                                    loadingPosition="start"
                                    startIcon={<TbTableExport size={18} />}
                                >
                                    <span style={{ fontSize: "14px", marginLeft: "4px" }}>EXPORT</span>
                                    <KeyboardArrowDownIcon />
                                </LoadingButton>

                                <StyledMenuButtons
                                    id="demo-customized-export-menu"
                                    MenuListProps={{
                                        "aria-labelledby": "demo-customized-export-menu",
                                        style: {
                                            maxHeight: 250,
                                        },
                                    }}
                                    anchorEl={anchorEl1}
                                    open={anchorEl1}
                                    onClose={() => handleCloseButton()}
                                >
                                    <MenuItem>
                                        {Utility.isReadAllowed(fullExcelPermission) &&
                                            <Button
                                                component="label"
                                                variant="outlined"
                                                size="small"
                                                color="secondary"
                                                sx={{
                                                    ml: "5px",
                                                    minWidth: buttonMinWidth,
                                                    justifyContent: "flex-start",
                                                    textAlign: "left",
                                                    "& .MuiButton-startIcon": {
                                                        marginRight: "1px",
                                                        marginLeft: "0px",
                                                    },
                                                }}
                                                startIcon={<Download />}
                                                onClick={() => {
                                                    getExcelData(row, true);
                                                    handleCloseButton()
                                                }}
                                            >
                                                FULL EXCEL
                                            </Button>
                                        }
                                    </MenuItem>
                                    <MenuItem>
                                        <Button
                                            component="label"
                                            variant="outlined"
                                            size="small"
                                            color="secondary"
                                            sx={{
                                                ml: "5px",
                                                minWidth: buttonMinWidth,
                                                justifyContent: "flex-start",
                                                textAlign: "left",
                                                "& .MuiButton-startIcon": {
                                                    marginRight: "1px",
                                                    marginLeft: "0px",
                                                },
                                            }}
                                            startIcon={<Download />}
                                            onClick={() => {
                                                getExcelData(row, false);
                                                handleCloseButton()
                                            }}
                                        >
                                            EXCEL
                                        </Button>
                                    </MenuItem>
                                </StyledMenuButtons>
                            </Box>
                        )}
                    </Box>
                </Box>
            </Stack>
        );
    }

    const handleClose = () => {
        setShowStoneDetailModal(false);
    };

    const columns = columnNames;
    const defaultMaterialTheme = createTheme();

    return (
        <div>
            {!access ? <NoPermission /> : (
                <Box px={1}>
                    <CommonSnackbar
                        show={errorSnackbar}
                        message={Constants.APiFailErrorMessage}
                        variant={"error"}
                        autoHide={Constants.SnackBarCloseTimer}
                        title={"Failed"}
                        handleClose={() => setErrorSnackbar(false)}
                    />

                    {showStoneDetailModal ? (
                        <StoneDetailModal
                            show={showStoneDetailModal}
                            stoneId={stoneId}
                            handleClose={handleClose}
                        />
                    ) : null}

                    {showStoneMediaModal ? (
                        <StoneMediaModal
                            show={showStoneMediaModal}
                            stoneMediaURL={stoneMediaURL}
                            handleClose={() => setShowStoneMediaModal(false)}
                        />
                    ) : null}

                    {showUserDetailModal ? (
                        <UserDetailModal
                            show={true}
                            handleClose={() => setShowUserDetailModal(false)}
                            handleSelect={(selectedOption) => {
                                const selectedCustomers = customerData.customerOptions.filter(opt =>
                                    selectedOption.includes(opt.value)
                                );
                                setCustomerData({
                                    ...customerData,
                                    customer: selectedCustomers,
                                });
                                setShowUserDetailModal(false)
                            }}
                            userids={customerData.customerOptions.filter(option => option.value !== "*").map(cust => cust.value)}
                            selectedIds={customerData.customer.length !== 0 ? customerData.customer.map(iCustomer => iCustomer.value) : []}
                            usertype={"C"}
                            loading={showUserDetailModal}
                            isMulti={true}
                        />
                    ) : null}

                    {/*need to send pdf in byte string to modal */}
                    <PDFModal show={isModalOpen} onHide={closeModal} pdfByteString={pdfByte} pdfName={pdfName} />

                    <Box sx={{ display: "flex", alignItems: "center", width: "100%", my: 1, gap: "10px" }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                width: "16%",
                                gap: "20px",
                            }}
                        >
                            <Box>
                                <Typography >Location</Typography>
                            </Box>
                            <Box sx={{ width: "100%" }}>
                                <Select menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    value={location}
                                    isSearchable={true}
                                    name="status"
                                    menuPortalTarget={document.body}
                                    styles={Constants.Styles}
                                    options={locationOptions}
                                    onChange={(selectedOption) => setLocation(selectedOption)}
                                />
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                width: "26%",
                                gap: "10px",
                            }}
                        >
                            <Box>
                                <Typography >Customer Company</Typography>
                            </Box>
                            <Box
                                sx={{
                                    alignSelf: "center",
                                    width: "66%",
                                    mt: 0,
                                    maxWidth: "90%",
                                    display: "inline-flex",
                                    alignItems: "center",
                                }}
                            >
                                <Box sx={{ flexGrow: 1 }}>
                                    <Select menuPlacement="auto"
                                        blurInputOnSelect={false}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        getOptionLabel={(option) => option.label}
                                        getOptionValue={(option) => option.value}
                                        value={customerData.customer}
                                        isSearchable={true}
                                        name="Customer"
                                        menuPortalTarget={document.body}
                                        styles={Constants.Styles}
                                        options={customerData.customerOptions}
                                        onChange={(selectedOption) => {
                                            setCustomerData({
                                                ...customerData,
                                                customer: selectedOption,
                                            });
                                        }}
                                    />
                                </Box>
                                <Tooltip title="View More Data">
                                    <span style={{ cursor: "pointer", marginLeft: "15px", marginTop: "0px" }}>
                                        <OpenInNewIcon
                                            fontSize="medium"
                                            color="action"
                                            onClick={() => setShowUserDetailModal(true)}
                                        />
                                    </span>
                                </Tooltip>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                width: "15%",
                                gap: "10px"
                            }}
                        >
                            <Box>
                                <Typography >Status</Typography>
                            </Box>
                            <Box sx={{ width: "100%" }}>
                                <Select menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    value={status}
                                    isSearchable={true}
                                    name="status"
                                    isMulti
                                    menuPortalTarget={document.body}
                                    styles={Constants.Styles}
                                    options={lStatusOption}
                                    onChange={(selectedOption) => setStatus(selectedOption)}
                                />
                            </Box>
                        </Box>
                        <Box
                            display={"flex"}
                            alignItems={"center"}
                            gap="10px"
                            width={"11%"}
                            sx={{
                                "& .MuiOutlinedInput-input": {
                                    height: "6px",
                                }
                            }}>
                            <Typography>From</Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    className="picker"
                                    ampm={true}
                                    renderInput={(props) => (
                                        <TextField
                                            fullWidth
                                            {...props}
                                            inputProps={{ ...props.inputProps, readOnly: true }}
                                        />
                                    )}
                                    value={fromDate}
                                    inputFormat="DD/MM/YYYY"
                                    onChange={(newValue) => {
                                        // Get the current time
                                        const now = dayjs();

                                        // Set startOfMonth to the first day of the selected month, but with the current system time
                                        const fromDate = dayjs(newValue)
                                            .hour(now.hour())
                                            .minute(now.minute())
                                            .second(now.second())
                                            .millisecond(now.millisecond())
                                            .toDate();

                                        setFromDate(fromDate);
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                        <Box
                            display={"flex"}
                            alignItems={"center"}
                            gap="10px"
                            width={"10%"}
                            sx={{
                                "& .MuiOutlinedInput-input": {
                                    height: "6px",
                                }
                            }}>
                            <Typography>To</Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    className="picker"
                                    ampm={true}
                                    renderInput={(props) => (
                                        <TextField
                                            fullWidth
                                            {...props}
                                            inputProps={{ ...props.inputProps, readOnly: true }}
                                        />
                                    )}
                                    error={false}
                                    value={toDate}
                                    inputFormat="DD/MM/YYYY"
                                    onChange={(newValue) => {
                                        // Get the current time
                                        const now = dayjs();

                                        // Set startOfMonth to the first day of the selected month, but with the current system time
                                        const toDate = dayjs(newValue)
                                            .hour(now.hour())
                                            .minute(now.minute())
                                            .second(now.second())
                                            .millisecond(now.millisecond())
                                            .toDate();

                                        setToDate(toDate);
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                        <Box sx={{ "& .MuiFormControlLabel-root": { m: 0 } }}>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <Switch
                                                checked={groupBy}
                                                onChange={() => setGroupBy(!groupBy)}
                                            />
                                            <Typography>By Proforma</Typography>
                                        </Box>
                                    }
                                    label=""
                                />
                            </FormGroup>
                        </Box>
                        <Box>
                            <LoadingButton
                                variant="contained"
                                onClick={() => handleSearch()}
                                startIcon={<SearchOutlinedIcon size="large" />}
                                loading={salesListLoader}
                                loadingPosition="start"
                                disabled={customerData.customer.length === 0}
                            >
                                Search
                            </LoadingButton>
                        </Box>
                    </Box>

                    {!groupBy ? (
                        <Box
                            sx={{
                                backgroundColor: '#fff',
                                color: '#000',
                                width: "94vw",
                                position: "relative",
                                "& .MuiTablePagination-selectLabel": {
                                    marginTop: "15px",
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    marginTop: "15px",
                                },
                                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                                    color: "#1976d2",
                                    padding: "4px 5px",
                                    borderRadius: "4px",
                                },
                                "& .css-cc8tf1": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                height: '76vh',
                            }}
                        >
                            <DataGridPro
                                disableRowSelectionOnClick={false}
                                density="compact"
                                columns={columns}
                                rows={mainData}
                                getRowId={(row) => row.performaid_stoneid}
                                sx={{
                                    '& .MuiDataGrid-columnHeader': {
                                        color: '#fff',
                                        backgroundColor: 'grey',
                                    },
                                    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                        py: "4px",
                                    },
                                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                        py: "12px",
                                    },
                                    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                        py: "18px",
                                    },

                                    fontSize: Constants.defaultTableFontSize, fontWeight: 'bold',
                                }}
                                checkboxSelection={true}
                                onRowSelectionModelChange={(newSelectionModel) => {
                                    setSelectionModel(newSelectionModel);
                                }}
                                rowSelectionModel={selectionModel}
                                slots={{ toolbar: GridToolbar }}
                                slotProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                    },
                                }}
                                initialState={{
                                    columns: {
                                        columnVisibilityModel: {
                                            // Hide columns id, the other columns will remain visible
                                            stonestatus: false,
                                        },
                                    },
                                    pagination: {
                                        paginationModel: Constants.pageSize,
                                    },
                                }}
                                pageSizeOptions={Constants.pageSizeOptions}
                                pagination
                            />
                            <Box sx={{
                                position: "absolute",
                                left: "0.4rem",
                                top: "1px"
                            }}>
                                <CommonStoneSelection title={"Enter Multiple Stone Ids"} handleSelection={handleSelection} buttonDisabled={mainData.length === 0} />
                            </Box>

                            <div
                                style={{
                                    position: "absolute",
                                    top: "6px",
                                    right: "17rem",
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    width: "45%",
                                    justifyContent: 'space-between',
                                    fontSize: Constants.defaultTableFontSize,
                                }}
                            >
                                <div style={{ alignItems: 'center', justifyContent: 'center', }}>

                                    <span>No of Stones: </span> <b>{noOfSelectedStones}</b> &nbsp;&nbsp;|&nbsp;&nbsp;
                                    <span>Total Weight: </span> <b>{selectedTotalSize}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                                    <span>Total Price: </span> <b>{selectedtotalPrice}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                                    <span>Avg Price: </span> <b>{selectedavgPrice}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                                    <span>Avg Discount: </span> <b>{selectedAvgDiscount}</b>
                                </div>
                                <div>
                                    {!Utility.isReadAllowed(fullExcelPermission) ? (
                                        <Button
                                            component="label"
                                            variant="outlined"
                                            size="small"
                                            color="secondary"
                                            sx={{ ml: "5px", }}
                                            startIcon={<Download size="large" />}
                                            onClick={() => getExcelData(mainData, false)}
                                        >
                                            EXCEL
                                        </Button>
                                    ) : (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                marginLeft: "5px",
                                                "& .MuiButton-startIcon": {
                                                    marginRight: "0px !important",
                                                    marginLeft: "-2px",
                                                },
                                                "& .MuiLoadingButton-loadingIndicator": { left: "7px" },
                                            }}
                                        >
                                            <LoadingButton
                                                id="demo-customized-export-menu"
                                                aria-controls={
                                                    open ? "demo-customized-export-menu" : undefined
                                                }
                                                aria-haspopup="true"
                                                aria-expanded={open ? "true" : undefined}
                                                variant="outlined"
                                                disableElevation
                                                onClick={handleClick}
                                                sx={{
                                                    color: "#2e7d32",
                                                    borderRadius: "4px",
                                                    border: "1px solid rgba(46, 125, 50, 0.5)",
                                                    padding: "2px 2px 2px 8px",
                                                    cursor: "pointer",
                                                }}
                                                loadingPosition="start"
                                                startIcon={<TbTableExport size={18} />}
                                            >
                                                <span style={{ fontSize: "14px", marginLeft: "4px" }}>EXPORT</span>
                                                <KeyboardArrowDownIcon />
                                            </LoadingButton>

                                            <StyledMenuButtons
                                                id="demo-customized-export-menu"
                                                MenuListProps={{
                                                    "aria-labelledby": "demo-customized-export-menu",
                                                    style: {
                                                        maxHeight: 250,
                                                    },
                                                }}
                                                anchorEl={anchorEl}
                                                open={anchorEl}
                                                onClose={() => handleCloseButton()}
                                            >
                                                <MenuItem>
                                                    {Utility.isReadAllowed(fullExcelPermission) &&
                                                        <Button
                                                            component="label"
                                                            variant="outlined"
                                                            size="small"
                                                            color="secondary"
                                                            sx={{
                                                                ml: "5px",
                                                                minWidth: buttonMinWidth,
                                                                justifyContent: "flex-start",
                                                                textAlign: "left",
                                                                "& .MuiButton-startIcon": {
                                                                    marginRight: "1px",
                                                                    marginLeft: "0px",
                                                                },
                                                            }}
                                                            startIcon={<Download />}
                                                            onClick={() => {
                                                                getExcelData(mainData, true);
                                                                handleCloseButton()
                                                            }}
                                                        >
                                                            FULL EXCEL
                                                        </Button>
                                                    }
                                                </MenuItem>
                                                <MenuItem>
                                                    <Button
                                                        component="label"
                                                        variant="outlined"
                                                        size="small"
                                                        color="secondary"
                                                        sx={{
                                                            ml: "5px",
                                                            minWidth: buttonMinWidth,
                                                            justifyContent: "flex-start",
                                                            textAlign: "left",
                                                            "& .MuiButton-startIcon": {
                                                                marginRight: "1px",
                                                                marginLeft: "0px",
                                                            },
                                                        }}
                                                        startIcon={<Download />}
                                                        onClick={() => {
                                                            getExcelData(mainData, false);
                                                            handleCloseButton()
                                                        }}
                                                    >
                                                        EXCEL
                                                    </Button>
                                                </MenuItem>
                                            </StyledMenuButtons>
                                        </Box>
                                    )}
                                </div>
                            </div>
                        </Box>
                    ) : (
                        <ThemeProvider theme={defaultMaterialTheme}>
                            <Box
                                sx={{
                                    backgroundColor: '#fff',
                                    color: '#000',
                                    width: "100%",
                                    position: "relative",
                                    "& .MuiTablePagination-selectLabel": {
                                        marginTop: "15px",
                                    },
                                    "& .MuiTablePagination-displayedRows": {
                                        marginTop: "15px",
                                    },
                                    "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                        fontWeight: Constants.defaultFontWeight,
                                    },
                                    "& .css-cc8tf1": {
                                        fontWeight: Constants.defaultFontWeight,
                                    },
                                    "& .lavenderCell": {
                                        color: "#080808",
                                        backgroundColor: "#D8BFD8",
                                    },
                                    height: "75vh",
                                }}
                            >
                                <DataGridPro
                                    rowHeight={65}
                                    disableRowSelectionOnClick={true}
                                    density="compact"
                                    columns={materialDefaultColumns}
                                    rows={listData}
                                    loading={salesListLoader}
                                    sx={{
                                        '& .MuiDataGrid-columnHeader': {
                                            color: '#fff',
                                            backgroundColor: 'grey',
                                        },
                                        "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                            py: "4px",
                                        },
                                        "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                            py: "12px",
                                        },
                                        "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                            py: "18px",
                                        },

                                        '& .MuiDataGrid-row': {
                                            whiteSpace: 'nowrap',
                                        },
                                        fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                                    }}
                                    slots={{ toolbar: GridToolbar }}
                                    slotProps={{
                                        toolbar: {
                                            showQuickFilter: true,
                                            quickFilterProps: { debounceMs: 500 },
                                        },
                                    }}
                                    getRowId={(row) => row.id}
                                    initialState={{
                                        pagination: {
                                            paginationModel: Constants.pageSize,
                                        },
                                    }}
                                    pageSizeOptions={Constants.pageSizeOptions}
                                    pagination
                                    getDetailPanelHeight={() => 'auto'}
                                    getDetailPanelContent={({ row }) => getDetailPanelContent(row, mainData, columns)}
                                />
                                <Box
                                    style={{
                                        position: "absolute",
                                        top: "6px",
                                        right: "265px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    {salesListLoader ? (
                                        <CircularProgress size="1rem" />
                                    ) : (
                                        <Tooltip title="Reload List">
                                            <RefreshOutlinedIcon
                                                onClick={() => setFetchUserData(true)}
                                                color="primary"
                                                fontSize="medium"
                                                sx={{ cursor: "pointer" }}
                                            />
                                        </Tooltip>
                                    )}
                                    <Button
                                        component="label"
                                        variant="outlined"
                                        size="small"
                                        color="secondary"
                                        sx={{ ml: "5px", }}
                                        startIcon={<Download size="large" />}
                                        onClick={() => createExcelFileByProforma()}
                                    >
                                        EXCEL
                                    </Button>
                                </Box>
                            </Box>
                        </ThemeProvider>
                    )}
                </Box>
            )}
        </div>
    );
};

export default ProformaAccount;
